import React from 'react';
import './i18n';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import App from './App';


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter>
        <div className="h-full">
            <App />
        </div>
    </BrowserRouter>
);